var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMobileProgramming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 18c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm4.16 2.19c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19l-1.73-1.73a.658.658 0 0 1 0-.92l1.73-1.73c.25-.25.66-.25.92 0 .25.25.25.66 0 .92L15.89 18l1.27 1.27c.25.25.25.66 0 .92zm2.59 0c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 0 1 0-.92L20.11 18l-1.27-1.27a.658.658 0 0 1 0-.92c.25-.25.66-.25.92 0l1.73 1.73c.24.26.24.66-.01.92l-1.73 1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.47c0 .35-.34.59-.66.47a6.485 6.485 0 0 0-3.65-.31c-2.6.52-4.67 2.65-5.1 5.27-.26 1.6.06 3.11.79 4.34a.5.5 0 0 1-.43.76H8c-3.5 0-5-2-5-5V7c0-2.66 1.18-4.53 3.89-4.92.29-.04.55.19.56.49l.03 1.01c.03 1.6 1.38 2.92 3 2.92h3.02c1.65 0 3-1.35 3-3v-.93c0-.3.26-.54.55-.5C19.8 2.44 21 4.32 21 7v4.47z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.5c0 .82-.68 1.5-1.5 1.5h-3.03c-.81 0-1.48-.65-1.5-1.46l-.01-.51a.991.991 0 0 1 1-1.03H14c.55 0 1 .45 1 1v.5z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMobileProgramming);
export default __webpack_public_path__ + "static/media/vuesax-bold-mobile-programming.d051a1b1d86ef13b4f1a63fa44123722.svg";
export { ForwardRef as ReactComponent };